$(function() {
  let fileEls = $('.form-file');

  fileEls.on('change', function() {
    let inputEl  = $(this).find('input');
    let filesEl  = $(this).find('.form-file__files');
    let filename = inputEl.val().split('\\').pop();
    
    if(filename) {
      filesEl.html('<div class="form-file__file">' + filename + '</div>')
    }
  });
});